<agpr-take-over-panel
    #takeOverPanel
    [id]="'manageSourceAgentsPanel'"
    class="agpr-manageSourceAgents"
    [header]="title"
    headerIcon="fa-kit-duotone fa-agpr-ai-generic"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="720"
    [maxPanelWidth]="960"
    [fullHeight]="true"
    [footerContext]="title"
    (visibleChange)="onVisibleChange($event)"
>
    @if (isEmpty) {
        <!-- No agents on the account yet, so the panel offers the first one rather than two empty tables -->
        <div class="agpr-manageSourceAgents-empty">
            <i class="fa-kit-duotone fa-agpr-ai-generic agpr-manageSourceAgents-emptyIcon" aria-hidden="true"></i>

            <h3 class="agpr-manageSourceAgents-emptyTitle">
                {{ 'AutomationAgents.hype.headline' | localize }}
            </h3>

            <p class="agpr-manageSourceAgents-emptyText">
                {{ 'AutomationAgents.manageSourceAgents.empty.description' | localize }}
            </p>

            <agpr-button
                [id]="'manageSourceAgentsPanel.emptyAddLiveAgent'"
                label="AutomationAgents.hype.link"
                [style]="buttonTypes.primary"
                (click)="createAgent()"
            ></agpr-button>
        </div>
    } @else {
        <div class="agpr-manageSourceAgents-body" [agprLoading]="loading">
            <section class="agpr-manageSourceAgents-section">
                <div class="agpr-manageSourceAgents-sectionHeader">
                    <h3 class="agpr-manageSourceAgents-heading">
                        {{ 'AutomationAgents.manageSourceAgents.liveAgents' | localize }}
                    </h3>

                    <div class="agpr-manageSourceAgents-headerControls">
                        <agpr-date-query-popup
                            [id]="'manageSourceAgentsPanel.range'"
                            [options]="rangeOptions"
                            [(ngModel)]="selectedRange"
                            (ngModelChange)="rangeSelected($event)"
                        ></agpr-date-query-popup>

                        <agpr-button
                            [id]="'manageSourceAgentsPanel.addLiveAgent'"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-square-plus"
                            tooltip="AutomationAgents.manageSourceAgents.addNewLiveAgent"
                            tooltipPosition="left"
                            [ariaLabel]="'AutomationAgents.manageSourceAgents.addNewLiveAgent' | localize"
                            (click)="addLiveAgent()"
                        ></agpr-button>
                    </div>
                </div>

                <agpr-table
                    [id]="'manageSourceAgentsPanel.liveAgents'"
                    class="agpr-manageSourceAgents-table"
                    [columns]="liveAgentColumns"
                    [sortColumn]="liveAgentNameColumn"
                    [sortAscending]="true"
                    [enableSelectAll]="false"
                    [actionMenu]="true"
                    [actionMenuIcons]="false"
                    actionMenuTextAlignment="right"
                    [showView]="true"
                    viewIcon="fa-regular fa-duotone fa-pen"
                    viewIconTooltip="AutomationAgents.agent.edit"
                    [showDelete]="true"
                    deleteLabel="AutomationAgents.card.source.remove"
                    [vsItemSize]="48"
                    [vsMinBufferPx]="400"
                    [vsMaxBufferPx]="800"
                    noContentMessage="AutomationAgents.manageSourceAgents.noLiveAgents"
                    [(ngModel)]="liveAgents"
                    (itemView)="editAgent($event?.agent)"
                    (itemDelete)="removeSource($event)"
                ></agpr-table>
            </section>

            <section class="agpr-manageSourceAgents-section">
                <div class="agpr-manageSourceAgents-sectionHeader">
                    <h3 class="agpr-manageSourceAgents-heading">
                        {{ 'AutomationAgents.agent.dashboard.adHocHistory' | localize }}
                    </h3>

                    <agpr-button
                        [id]="'manageSourceAgentsPanel.runAdHoc'"
                        [style]="buttonTypes.icon"
                        icon="fa-regular fa-duotone fa-square-plus"
                        tooltip="AutomationAgents.agent.dashboard.addAdHoc"
                        tooltipPosition="left"
                        [ariaLabel]="'AutomationAgents.agent.dashboard.addAdHoc' | localize"
                        (click)="runAdHoc()"
                    ></agpr-button>
                </div>

                <agpr-table
                    [id]="'manageSourceAgentsPanel.adHocHistory'"
                    class="agpr-manageSourceAgents-table"
                    [columns]="adHocColumns"
                    [sortColumn]="adHocDateColumn"
                    [sortAscending]="false"
                    [enableSelectAll]="false"
                    [actionMenu]="true"
                    [actionMenuIcons]="false"
                    actionMenuTextAlignment="right"
                    [showView]="true"
                    viewIconTooltip="AutomationAgents.agent.dashboard.adHoc.viewReport"
                    [vsItemSize]="48"
                    [vsMinBufferPx]="400"
                    [vsMaxBufferPx]="800"
                    noContentMessage="AutomationAgents.agent.dashboard.adHocHistory.empty"
                    [(ngModel)]="adHocHistory"
                    (itemView)="viewReport($event)"
                ></agpr-table>
            </section>
        </div>
    }

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="'manageSourceAgentsPanel.close'"
            label="Core.button.close"
            [style]="buttonTypes.secondary"
            (click)="close()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

<ng-template #statusCell let-row="row">
    <agpr-social-switch
        [id]="'manageSourceAgentsPanel_agent_' + row.source?.id + '_status'"
        class="agpr-manageSourceAgents-sourceStatus"
        [ngClass]="{
            'agpr-manageSourceAgents-sourceStatus--active': row.source?.isActive,
            'agpr-manageSourceAgents-sourceStatus--error': row.source?.hasError,
            'agpr-manageSourceAgents-sourceStatus--standby': row.source?.isStandby
        }"
        [onText]="'AutomationAgents.card.source.active'"
        [tooltip]="row.source?.isStandby ? 'AutomationAgents.card.source.standby.tooltip' : null"
        [offText]="`AutomationAgents.card.source.${row.source?.status}`"
        [initiallyFocusable]="false"
        [ngModel]="row.isActive"
        (ngModelChange)="statusChanged(row, $event)"
    ></agpr-social-switch>
</ng-template>

<!-- The agent opens in its own tab, so the panel and the source behind it are left as they were -->
<ng-template #agentCell let-row="row">
    <a
        class="agpr-manageSourceAgents-agentLink"
        [href]="agentUrl(row.agent)"
        target="_blank"
        rel="noopener"
        [pTooltip]="row.agentName"
        tooltipPosition="top"
    >{{ row.agentName }}</a>
</ng-template>
